import { Box, Text } from '@mantine/core';
import { OTP_DIGITS_NUMBER } from 'consts';
import type { ChangeEvent, RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from 'shared/ui/Inputs';
import type { Props as TextInputProps } from 'shared/ui/Inputs/TextInput';

import { OtpLabel } from './OtpLabel';
import { ResendOtpDataButton } from './ResendOtpDataButton';

type Props = {
  error?: string;
  codeNumber: number;
  validUntil: string;
  method?: string;
  isGettingOtpData: boolean;
  resendCode: () => void;
  textInputProps: TextInputProps & {
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    ref: RefObject<HTMLInputElement>;
  };
};

export const OtpFlow = ({
  error,
  codeNumber,
  validUntil,
  method,
  isGettingOtpData,
  resendCode,
  textInputProps: { onChange, ...textInputProps },
}: Props) => {
  const { t } = useTranslation('user');

  return (
    <div>
      <TextInput
        sx={{
          input: {
            letterSpacing: 10,
          },
        }}
        error={error && t(error)}
        label={
          <OtpLabel
            method={method}
            codeNumber={codeNumber}
            validUntil={validUntil}
          />
        }
        placeholder="000000"
        autoComplete="off"
        onChange={e => {
          onChange({
            ...e,
            target: {
              ...e.target,
              value: e.target.value
                .replace(/\D/g, '')
                .slice(0, OTP_DIGITS_NUMBER),
            },
          });
        }}
        {...textInputProps}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Text
          sx={theme => ({
            marginRight: theme.other.spacing(0.5),
          })}
          size="lg"
        >
          {t('user:codeNotArrive')}
        </Text>
        <ResendOtpDataButton
          isGettingOtpData={isGettingOtpData}
          onClick={resendCode}
        />
      </Box>
    </div>
  );
};
